module.exports = __webpack_public_path__ + "img/poulpe_loupe.7d1d1d9d.png";